import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'

import { QuarterlyDashboardFacade } from '~/core/features'
import { MetaTagService } from '~/core/services'

export const quarterlyDashboardQuarterDataResolver: ResolveFn<void> = () => {
  inject(MetaTagService).setQuarterlyDashboardPageMeta()

  return inject(QuarterlyDashboardFacade).getQuarterlyDashboardQuarterData()
}
